import { Box, Typography } from '@mui/material';
import Header from '@components/Header';
import { useStyles } from './useStyles';

const HeroSection = () => {
  const classes = useStyles();

  return (
    <Box className={classes.mainContainer}>
      <Box sx={{ background: 'rgba(29,28,27,0.2)' }}>
        <Box className={classes.headerContainer}>
          <Header isBackground={false} />
        </Box>

        <Typography
          variant="h1"
          align="center"
          color="whitePepper.main"
          className={classes.title}
        >
          The Cumin Blog
        </Typography>
      </Box>
    </Box>
  );
};

export default HeroSection;
